import { useState } from 'react';
import styles from './Discount.module.scss';


type Props = {
  id: string,
  hide: React.Dispatch<React.SetStateAction<boolean>>,
  startPrice: number,
  finalPrice: number,
  makeDiscount: (id: string, newPrice: number) => void,
}


export const Discount: React.FC<Props> = ({ id, hide, startPrice, finalPrice, makeDiscount }) => {

  const len = String(Math.floor(startPrice)).length;

  const [newPrice, setNewPrice] = useState(finalPrice);

  const discount = newPrice / startPrice;
  const discountPercent = Math.round((1 - discount) * 100);


  const down = (number: number, rank: number) => (
    Math.floor((number - 0.001) / Math.pow(10, rank)) * Math.pow(10, rank)
  )

  const up = (number: number, rank: number) => (
    Math.ceil((number + 0.001) / Math.pow(10, rank)) * Math.pow(10, rank)
  )



  return (
    <div className={styles.Discount}>

      {discount !== 1
        ? <button onClick={() => setNewPrice(startPrice)}
          style={{
            gridArea: "startPrice",
            textDecoration: "line-through"
          }}>
          {startPrice.toLocaleString('ru')}
        </button>
        : <p style={{
          gridArea: "startPrice",
        }}>
          {startPrice.toLocaleString('ru')}
        </p>
      }


      {!!discountPercent &&
        <button onClick={() => setNewPrice(Math.round(startPrice * (100 - discountPercent + 1) / 100))}
          style={{
            gridArea: "downPercent"
          }}
        >
          - {discountPercent - 1}%
        </button>
      }

      <p style={{
        gridArea: "percent"
      }}>
        - {discountPercent}%
      </p>

      {discountPercent + 1 <= 100 &&
        <button onClick={() => setNewPrice(Math.round(startPrice * (100 - discountPercent - 1) / 100))}
          style={{
            gridArea: "upPercent"
          }}
        >
          - {discountPercent + 1}%
        </button>
      }

      {
        up(newPrice, len - 2) <= startPrice &&
        up(newPrice, len - 2) !== up(newPrice, len - 3) &&

        <button onClick={() => setNewPrice(prev => up(prev, len - 2))}
          style={{
            gridArea: "dubleUpPrice"
          }}
        >
          {up(newPrice, len - 2).toLocaleString('ru')}
        </button>
      }
      {
        len > 2 &&
        up(newPrice, len - 3) <= startPrice &&

        <button onClick={() => setNewPrice(prev => up(prev, len - 3))}
          style={{
            gridArea: "upPrice"
          }}
        >
          {up(newPrice, len - 3).toLocaleString('ru')}
        </button>
      }
      {
        up(newPrice, len - 3) > startPrice &&
        newPrice !== startPrice &&

        <button onClick={() => setNewPrice(prev => startPrice)}
          style={{
            gridArea: "upPrice"
          }}
        >
          {startPrice.toLocaleString('ru')}
        </button>
      }


      <p style={{
        gridArea: "newPrice",
        fontWeight: "bold"

      }}> {newPrice.toLocaleString('ru')} руб.</p>

      {
        len > 2 &&
        down(newPrice, len - 3) >= 0 &&

        <button onClick={() => setNewPrice(prev => down(prev, len - 3))}
          style={{
            gridArea: "downPrice"
          }}
        >
          {down(newPrice, len - 3).toLocaleString('ru')}
        </button>
      }
      {
        down(newPrice, len - 2) >= 0 &&
        down(newPrice, len - 2) !== down(newPrice, len - 3) &&

        <button onClick={() => setNewPrice(prev => down(prev, len - 2))}
          style={{
            gridArea: "dubleDownPrice"
          }}
        >
          {down(newPrice, len - 2).toLocaleString('ru')}
        </button>
      }

      <button className={styles.btn} onClick={() => { makeDiscount(id, newPrice); hide(true) }}> ok </button>
      <button className={`${styles.btn} ${styles.no}`} onClick={() => hide(true)}> no </button>

    </div >
  )
}

